<template>
    <!-- Content Wrapper. Contains page content -->
    <div  class="logs">
        <iframe id="iframe" :src="urlLogsIframe" frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%;min-height: 950px;"></iframe>

      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
  </template>

  <script>
  import { mapStores } from 'pinia';
  import { useUserStore } from '@/Stores/user';
  export default {
    name: 'logs',
    data(){
      return {
        urlLogsIframe:'/admin/logs/frame'
      }
    },
    computed: {
        ...mapStores(useUserStore),
    },
    created () {
          //this.$store.commit('setPageTitle','LOGS');
    },
    mounted() {
      //this.$store.commit('setPageTitle','LOGS');
      //this.fix_iframe();
      /*setTimeout(()=>{
                    //console.log( window.Tawk_API)
                    if(_.has(window.Tawk_API,'hideWidget'))
                        window.Tawk_API.hideWidget();
                },2800)*/
                //userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns"
    },
    methods: {
      /*fix_iframe() {
          var height = $(window).height() - $("body > .header").height();
          $("#iframe").css("min-height", height - 2 + "px");
      }*/
    },
  }
  </script>

  <style>
  .page-enter-active, .page-leave-active {
    transition: opacity 0.5s, transform 0.5s;
  }
  .page-enter, .page-leave-to {
    opacity: 0;
  }
  </style>
